<script>
    import { onMount } from 'svelte';

    export let items;
    export let activeTabValue;

    onMount(() => {
        if (Array.isArray(items) && items.length && items[0].value) {
            activeTabValue = items[0].value;
        }
    });

    function handleClick(tabValue){
        activeTabValue = tabValue
    }
</script>

<ul class="nav nav-tabs">
    {#if Array.isArray(items)}
        {#each items as item}
            <li class={activeTabValue === item.value ? 'active' : 'nav-item'}>
                <span id="tab-{item.label}" class="nav-link" on:mousedown={handleClick(item.value)}>{item.label}</span>
            </li>
        {/each}
    {/if}
</ul>

<style>
    .nav-tabs{
        border: none;
    }

    .nav-tabs li{
        background-color: #ccced4;
        border-radius: 8px 8px 0px 0px;
    }

    li.active{
        background-color: #3B71CA;
        color: white;
        border:1px solid #e3e6f0;
        border-bottom: transparent;
    }

    .nav-link{
        cursor: pointer;
    }
</style>

